import { render, staticRenderFns } from "./TreatmentPlanRequestUploadPlanModal.vue?vue&type=template&id=2b88d4cc&scoped=true&"
import script from "./TreatmentPlanRequestUploadPlanModal.vue?vue&type=script&lang=js&"
export * from "./TreatmentPlanRequestUploadPlanModal.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentPlanRequestUploadPlanModal.vue?vue&type=style&index=0&id=2b88d4cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b88d4cc",
  null
  
)

export default component.exports